e<template>
  <v-container
      fluid
  >
    <v-card class="pa-5" tile>

      <v-form
        autocomplete="off"
        @submit="function(e){saveItem();e.preventDefault()}"
      >

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Status') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.status_ids"
                    :error-messages="errors.status_ids"
                    :items="statuses"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="10"
                />
            </v-col>
        </v-row>
      
        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Date of visit') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_date"
                :error-messages="errors.from_date"
                :label="undefined"
                clearable
                tabindex="20"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_date"
                :error-messages="errors.to_date"
                :label="undefined"
                clearable
                tabindex="25"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Appointment location') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.appointment_location_ids"
                    :error-messages="errors.appointment_location_ids"
                    :items="appointment_locations"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="30"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" sm="2" class="px-0">
                {{ $t('Action') }}
            </v-col>
            <v-col cols="2" sm="2" class="px-0">
                <v-btn @click="resetForm">{{ $t('Clear form') }}</v-btn>
                &nbsp;
                <v-btn @click="exportXls">{{ $t('Export XLS') }}</v-btn>
            </v-col>
        </v-row>

      </v-form>

    </v-card>
  </v-container>

</template>

<script>
import ApiService from '@/services/api.service'
import DatePickerField from '@/components/DatePickerField'
import {fetchMultipleLists} from '@/lib/helpers'

export default {
  components: {
    DatePickerField,
  },
  data: () => ({
    errors: {},
    search: {},
    statuses: [],
    appointment_locations: [],
  }),
  watch: {
    '$i18n.locale': function () {
        this.fetchTranslatables()
    },
  },
  methods: {
    resetForm() {
      this.search = {
        status_ids: null,
        from_date: null,
        to_date: null,
        appointment_location_ids: null,
      }
    },
    getItem() {
      const item = this.search
      return item
    },
    exportXls() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')

      ApiService.download(`/exports/milk-project-monthly/xls`, { filter: this.search }).then(response => {
        this.openFile(response.data, response.filename)
      }).catch(errors => {
        this.errors = errors
        console.log(errors)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    openFile(blob, filename) {
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download=filename;
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    },  
    fetchTranslatables() {
        fetchMultipleLists(this, {
            // These must be listed in created() as well
            module_status: 'statuses',
        }, '/master-files/get-multiple-lists', 'master_file_type_tags')
    },
  },
  created() {
    this.resetForm();
    this.$store.dispatch('session/title', 'Reports - Milk project monthly statistics')
    fetchMultipleLists(this, {
        // Non-translatable
        appointments_where: 'appointment_locations',

        // Translatable; must be listed in fetchTranslatables() as well
        module_status: 'statuses',
    }, '/master-files/get-multiple-lists', 'master_file_type_tags')
  },
}
</script>

<style scoped>

</style>
